'use strict';

const DIALOG_REGISTRY = require('../dialog.registry');

module.exports = (app) => app.controller('materialGroupSelectionDialog', /* @ngInject */ function ($scope, dialogService, materialGroupService, $timeout) {
    let dialogId = null;

    $scope.query = {
        search: '',
    };
    $scope.context = {
        companyCodeId: '',
        companyCode: '',
    };
    $scope.searchResults = [];
    $scope.searchLoading = false;
    $scope.tree = [];
    $scope.treeLoading = false;
    $scope.childrenLoading = {};
    $scope.childrenByParent = {};
    $scope.treeOpenState = {};

    $scope.init = init;
    $scope.search = search;
    $scope.select = select;
    $scope.cancel = cancel;
    $scope.toggleNode = toggleNode;
    $scope.isOpen = isOpen;
    $scope.hasChildrenLoaded = hasChildrenLoaded;

    function init() {
        dialogId = DIALOG_REGISTRY.MATERIAL_GROUP_SELECTION.id;
        const dialogData = dialogService.getData(dialogId) || {};
        $scope.context = normalizeContext(dialogData?.context || dialogData);

        loadRootGroups();
        search('');
    }

    function search(query = '') {
        const searchInput = document.getElementById('materialGroupSearch');
        const hadFocus = document.activeElement === searchInput;
        const selectionStart =
            hadFocus && searchInput && typeof searchInput.selectionStart === 'number'
                ? searchInput.selectionStart
                : null;
        const selectionEnd =
            hadFocus && searchInput && typeof searchInput.selectionEnd === 'number'
                ? searchInput.selectionEnd
                : null;

        $scope.searchLoading = true;
        materialGroupService
            .search(query, $scope.context)
            .then((groups) => {
                $scope.searchResults = groups || [];
            })
            .catch((error) => {
                console.error(error);
                $scope.searchResults = [];
            })
            .finally(() => {
                $scope.searchLoading = false;
                applySafe();
                if (hadFocus) {
                    restoreSearchFocus(selectionStart, selectionEnd);
                }
            });
    }

    function loadRootGroups() {
        $scope.treeLoading = true;
        materialGroupService
            .getRootGroups($scope.context)
            .then((groups) => {
                $scope.tree = groups || [];
            })
            .catch((error) => {
                console.error(error);
                $scope.tree = [];
            })
            .finally(() => {
                $scope.treeLoading = false;
                applySafe();
            });
    }

    function toggleNode(group, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        if (!group?.hasChildren) {
            return;
        }

        const id = group.id;
        if ($scope.treeOpenState[id]) {
            delete $scope.treeOpenState[id];
            return;
        }

        $scope.treeOpenState[id] = true;
        if (!hasChildrenLoaded(id)) {
            loadChildren(id);
        }
    }

    function loadChildren(parentId) {
        if (!parentId) {
            return;
        }

        $scope.childrenLoading[parentId] = true;
        materialGroupService
            .getChildren(parentId, $scope.context)
            .then((groups) => {
                $scope.childrenByParent[parentId] = groups || [];
            })
            .catch((error) => {
                console.error(error);
                $scope.childrenByParent[parentId] = [];
            })
            .finally(() => {
                $scope.childrenLoading[parentId] = false;
                applySafe();
            });
    }

    function isOpen(group) {
        return !!$scope.treeOpenState[group?.id];
    }

    function hasChildrenLoaded(parentId) {
        return Object.prototype.hasOwnProperty.call($scope.childrenByParent, parentId);
    }

    function select(group) {
        dialogService.closeDialog(dialogId, group);
    }

    function cancel() {
        dialogService.closeDialog(dialogId);
    }

    function applySafe() {
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }

    function restoreSearchFocus(selectionStart, selectionEnd) {
        const focusInput = document.getElementById('materialGroupSearch');
        if (focusInput && typeof focusInput.focus === 'function') {
            focusInput.focus();
            if (typeof selectionStart === 'number' && typeof selectionEnd === 'number') {
                focusInput.setSelectionRange(selectionStart, selectionEnd);
            }
            return;
        }

        $timeout(() => {
            const delayedInput = document.getElementById('materialGroupSearch');
            if (delayedInput && typeof delayedInput.focus === 'function') {
                delayedInput.focus();
                if (typeof selectionStart === 'number' && typeof selectionEnd === 'number') {
                    delayedInput.setSelectionRange(selectionStart, selectionEnd);
                }
            }
        }, 0);
    }

    function normalizeContext(context) {
        return {
            companyCodeId: normalizeValue(context?.companyCodeId),
            companyCode: normalizeValue(context?.companyCode),
            customerCompanyId: normalizeValue(context?.customerCompanyId),
        };
    }

    function normalizeValue(value) {
        if (typeof value === 'undefined' || value === null) {
            return '';
        }

        return String(value).trim();
    }
});
